export const setIsLoggedIn = '@authentication/setIsLoggedIn';
export const SET_PERMISSIONS = '@authentication/setPermissions';
export const SET_COMPANY_LIST = '@customization/setCompanyList';
export const SET_COMPANY_CREATOR_FLAG = '@customization/setCompanyCreatorFlag';
export const SET_AUTHENTICATED_USER_DATA = '@customization/setAuthenticatedUserData';
export const SET_COMPANY_VALIDATED = '@customization/setCompanyValidated';
export const SET_SUBSCRIBED = '@customization/setSubscribed';
export const SHOW_NOT_VALIDATED = '@customization/showNotValidated';
export const SHOW_NOT_SUBSCRIBED = '@customization/showNotSubscribed';
export const SHOW_NOT_SUBSCRIBED_NON_CREATOR = '@customization/showNotSubscribedNonCreator';
export const SET_PAGE_PERMISSIONS = '@authentication/SET_PAGE_PERMISSIONS';
